import { TypeInventoryIncident } from '../../interfaces/Configuration/Configuration'
import { TypeInventoryIncidentAction } from '../actions/typeInventoryIncidentActions'
import { GET_TYPE_INVENTORY_INCIDENT_EXITO } from '../types/typeInventoryIncidentActionsTypes'

export interface TypeInventoryIncidentState {
  typeInventoryIncidentState: {
    typeInventoryIncident: TypeInventoryIncident[]
    error?: string | undefined
  }
}

const initialState: TypeInventoryIncidentState = {
  typeInventoryIncidentState: { typeInventoryIncident: [], error: '' }
}

export const typeInventoryIncidentReducer = (
  state: TypeInventoryIncidentState = initialState,
  action: TypeInventoryIncidentAction
): TypeInventoryIncidentState => {
  if (action.type === GET_TYPE_INVENTORY_INCIDENT_EXITO) {
    return {
      ...state,
      typeInventoryIncidentState: {
        typeInventoryIncident: action.typeInventoryIncident,
        error: action.error
      }
    }
  }
  return state
}
